import { useMutation } from '@tanstack/react-query';

import { createAssuTask } from 'wg-api-sdk';

import wgApi from '@/lib/api/wgApi';

import type { CreateTaskVariablesAssu } from '../types';

export default function useCreateTaskAssu() {
  return useMutation({
    mutationFn: ({ crmPartyId, documents, ...task }: CreateTaskVariablesAssu) =>
      createAssuTask(
        {
          params: {
            path: { assu_id: crmPartyId },
            query: {},
          },
          body: {
            ...task,
            documents: documents?.map((doc) => ({
              ...doc,
              description: task.title,
              due_date: task.dueDate ?? undefined,
            })),
          },
        },
        wgApi,
      ),
  });
}
